import pclnExpt from '@pcln/experimentation'

export function initializePclnExpt (appCode = '', productID = '') {
  const experimentMetadata = {
    appCode,
    globalPartnerCode: 'PCLN',
    plfCode: 'PCLN',
    clientIP: window.PCLN_BOOTSTRAP_DATA.webstats.resolvedClientIP,
    productID,
    productSubType: 'ALL',
    serverTimestamp: window.PCLN_BOOTSTRAP_DATA.webstats.requestTime,
    referralClickID: window.PCLN_BOOTSTRAP_DATA.referral.clickId,
    referralID: window.PCLN_BOOTSTRAP_DATA.referral.id,
    referralSourceID: window.PCLN_BOOTSTRAP_DATA.referral.sourceId
  }

  const config = {
    useBatching: true,
    timeOutForApiCalls: '8000' // optional. By default api timeout for seti calls is 5000 ms. If this need to be altered then pass this parameter
  }
  pclnExpt.initialize(window.PCLN_BOOTSTRAP_DATA.fullSETI, experimentMetadata, config)
}

export function clearBatch () {
  pclnExpt.clearBatch()
}
